import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "report-viewer-page" }
const _hoisted_2 = {
  key: 1,
  class: "report-viewer-error"
}

import { ref, onMounted, onBeforeUnmount, nextTick } from "vue";
import { useRoute } from "vue-router";
import Loader from "@/components/Loader.vue";
import { usePowerBiEmbed } from "@/composables/reports/usePowerBiEmbed";
import { $api } from "@/services/api1";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportViewer',
  setup(__props) {

const route = useRoute();
const container = ref<HTMLDivElement | null>(null);
const { isLoading, error, embed, reset } = usePowerBiEmbed();

onMounted(async () => {
  await nextTick();

  const id = Number(route.params.id);
  if (!container.value || Number.isNaN(id)) {
    error.value = "Report not found.";
    return;
  }

  isLoading.value = true;
  const token = await $api.reports.getEmbedToken(id);

  if (!token || !token.token) {
    error.value =
      "There was an issue opening the report. Please try again later or contact Member Support.";
    isLoading.value = false;
    return;
  }

  embed(container.value, token);
});

onBeforeUnmount(() => {
  reset();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isLoading))
      ? (_openBlock(), _createBlock(Loader, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(error))
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(error)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref_key: "container",
      ref: container,
      class: "report-viewer-embed"
    }, null, 512)
  ]))
}
}

})